import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButton} from 'mui-tiptap';

const StyledEditorMenuButtonDialog = styled(MenuButton)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonDialog;
